import React, { useEffect, useState } from "react";
import AuthService from "../../../api/services/AuthService";
import { alertSuccessMessage, alertErrorMessage } from "../../../customComponent/CustomAlertMessage";
import Swal from 'sweetalert2';

const CreateEarningPackage = () => {
  const [formData, setFormData] = useState({
    currencyId: "",
    duration_days: '',
    return_percentage_monthly: "",
    return_percentage_yearly: "",
    min_amount: "",
    max_amount: "",
    type: "",
    user_type: ""
  });

  const [currencyList, setCurrencyList] = useState([]);
  const [packageList, setPackageList] = useState([]);
  const [editingPackageId, setEditingPackageId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const typesList = [
    { id: "FIP", name: "FIP" },
    { id: "SIP", name: "SIP" },
  ];
  const userTypesList = [
    { id: "ADMIN", name: "Admin" },
    { id: "USER", name: "User" }
  ]

  useEffect(() => {
    fetchAllPackageList();
    fetchCurrencyList();
  }, []);

  const fetchCurrencyList = async () => {
    try {
      const result = await AuthService.getCoinList();
      if (result.success) {
        setCurrencyList(result.data);
      }
    } catch {
      alertErrorMessage("Failed to fetch currencies");
    }
  };

  const fetchAllPackageList = async () => {
    try {
      const result = await AuthService.allPackageList();
      if (result.success) {
        setPackageList(result.data);
      }
    } catch {
      alertErrorMessage("Failed to fetch packages");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    if(name == "type" && value == "FIP"){
      setFormData(prev => ({ ...prev, duration_days: 1 }));
      setFormData(prev => ({ ...prev, max_amount: 0 }));
    }
      
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const { currencyId, duration_days, return_percentage_monthly, return_percentage_yearly, min_amount, max_amount, type, user_type } = formData;
    if (!currencyId || !duration_days || !return_percentage_monthly || !return_percentage_yearly || !min_amount || !max_amount || !type || !user_type) {
      return alertErrorMessage("All fields are required.");
    }

    try {
      let result;
      if (isEditMode && editingPackageId) {
        // Update existing package
        const updatedData = {
          currencyId,
          duration_days: (type == "FIP") ? 1*365 : +duration_days,
          return_percentage_monthly: +return_percentage_monthly,
          return_percentage_yearly: +return_percentage_yearly,
          min_amount: +min_amount,
          max_amount: +max_amount,
          type,
          user_type: user_type.toUpperCase()
        };
        result = await AuthService.editPackage(editingPackageId, updatedData);
      } else {
        // Create new package
        const finalDuration = (type == "FIP") ? 1*365 : +duration_days;
        console.log("Creating package with data:", {
          currencyId,
          duration_days: finalDuration,
          return_percentage_monthly: +return_percentage_monthly,
          return_percentage_yearly: +return_percentage_yearly,
          min_amount: +min_amount,
          max_amount: +max_amount,
          type,
          user_type
        });
        result = await AuthService.addPackage(currencyId, finalDuration, +return_percentage_monthly, +return_percentage_yearly, +min_amount, +max_amount, type, user_type);
      }
      
      if (result?.success) {
        alertSuccessMessage(result.message);
        setFormData({
          currencyId: "",
          duration_days: '',
          return_percentage_monthly: "",
          return_percentage_yearly: "",
          min_amount: "",
          max_amount: "",
          type: "",
          user_type: ""
        });
        setIsEditMode(false);
        setEditingPackageId(null);
        fetchAllPackageList();
      } else {
        alertErrorMessage(result?.message);
      }
    } catch {
      alertErrorMessage("Something went wrong.");
    }
  };

  const handleEditPackage = (pkg) => {
    setIsEditMode(true);
    setEditingPackageId(pkg._id);
    setFormData({
      currencyId: pkg.currency_id,
      duration_days: pkg.type === "FIP" ? 1 : pkg.duration_days / 365,
      return_percentage_monthly: pkg.return_percentage_monthly,
      return_percentage_yearly: pkg.return_percentage_yearly,
      min_amount: pkg.min_amount,
      max_amount: pkg.max_amount,
      type: pkg.type,
      user_type: pkg.user_type
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleCancelEdit = () => {
    setIsEditMode(false);
    setEditingPackageId(null);
    setFormData({
      currencyId: "",
      duration_days: '',
      return_percentage_monthly: "",
      return_percentage_yearly: "",
      min_amount: "",
      max_amount: "",
      type: "",
      user_type: ""
    });
  };

  const toggleStatus = async (pkg) => {
    try {
      const newStatus = pkg.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";
      const result = await AuthService.updatePackageStatus(pkg._id, newStatus);
      if (result.success) {
        alertSuccessMessage("Status updated");
        fetchAllPackageList();
      } else {
        alertErrorMessage(result.message);
      }
    } catch {
      alertErrorMessage("Failed to update status");
    }
  };


  const deletePackage = async (pkg) => {
    
    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: `You are about to delete the package for ${pkg.currency}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    });
  
    if (confirm.isConfirmed) {
      try {
        const result = await AuthService.deletePackage(pkg._id);
        if (result?.success) {
          alertSuccessMessage("Package Deleted");
          fetchAllPackageList();
        } else {
          alertErrorMessage(result.message);
        }
      } catch {
        alertErrorMessage("Failed to delete package");
      }
    }
  };
  
  return (
    <div id="layoutSidenav_content">
      <main>
        <header className="page-header page-header-dark bg-gradient-primary-to-secondary pb-10">
          <div className="container-xl px-4">
            <div className="page-header-content pt-4">
              <div className="row align-items-center justify-content-between">
                <div className="col-auto mt-4">
                  <h1 className="page-header-title">
                    <div className="page-header-icon"><i className="fas fa-box"></i></div>
                    Create Earning Package
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </header>

        <div className="container-xl px-4 mt-n10">
          <div className="card mb-4">
            <div className="card-header">{isEditMode ? 'Edit Package Details' : 'New Package Details'}</div>
            <div className="card-body">
              <form className="row gx-3 mb-3">
                {/* Currency Select */}
                 <div className="col-md-6">
                  <label className="small mb-1">Currency <em>*</em></label>
                  <select className="form-select" name="currencyId" value={formData.currencyId} onChange={handleChange}>
                    <option value="" style={{color: '#666'}}>Select Currency</option>
                    {currencyList.map(currency => (
                      <option key={currency._id} value={currency._id} style={{color: '#333'}}>{currency.name} ({currency.short_name})</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="small mb-1">Type Of Investment <em>*</em></label>
                  <select className="form-select" name="type" value={formData.type} onChange={handleChange}>
                    <option value="" style={{color: '#666'}}>Select Type Of Investment</option>
                    {typesList.map(type => (
                      <option key={type.id} value={type.id} style={{color: '#333'}}>{type.name}</option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6">
                  <label className="small mb-1">User Type <em>*</em></label>
                  <select className="form-select" name="user_type" value={formData.user_type} onChange={handleChange}>
                    <option value="" style={{color: '#666'}}>Select User Type</option>
                    {userTypesList.map(type => (
                      <option key={type.id} value={type.id} style={{color: '#333'}}>{type.name}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="small mb-1">Duration (Year's)<em>*</em></label>
                  <input type="number" name="duration_days" disabled={formData.type === "FIP" || formData.duration_days === ""} value={formData.duration_days} onChange={handleChange} className="form-control" />
                </div>
                {/* Form Inputs */}
                {["return_percentage_monthly", "return_percentage_yearly", "min_amount"].map((field, i) => (
                  <div key={i} className="col-md-6">
                    <label className="small mb-1">{field.replace(/_/g, ' ').toUpperCase()} <em>*</em></label>
                    <input type="number" name={field} value={formData[field]} onChange={handleChange} className="form-control" />
                  </div>
                ))}
                <div className="col-md-6">
                  <label className="small mb-1">Max Amount <em>*</em></label>
                  <input type="number" name="max_amount" disabled={formData.type !== "FIP"} value={formData.max_amount} onChange={handleChange} className="form-control" />
                </div>
              </form>
              <button type="button" className="btn btn-primary me-2" onClick={handleSubmit}>
                {isEditMode ? 'Update Package' : 'Create Package'}
              </button>
              {isEditMode && (
                <button type="button" className="btn btn-secondary" onClick={handleCancelEdit}>
                  Cancel Edit
                </button>
              )}
            </div>
          </div>

          {/* Packages Table */}
          {packageList.map((group, i) => (
            <div key={i} className="card mb-4">
              <div className="card-header">
                {/* <img src={`${ApiConfig?.appUrl}${group[0].icon_path}`} alt="coin" width="20" className="me-2" /> */}
                {group[0].currency_fullname} ({group[0].currency})
              </div>
              <div className="card-body table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Plan Id</th>
                      <th>Duration</th>
                      <th>Min</th>
                      <th>Max</th>
                      <th>Monthly %</th>
                      <th>Yearly %</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {group.map(pkg => (
                      <tr key={pkg._id}>
                         <td>
                          <span className={` dge`}>
                            {pkg.plan_id}
                          </span>
                        </td>
                        {["duration_days", "min_amount", "max_amount", "return_percentage_monthly", "return_percentage_yearly"].map(key => (
                          <td key={key}>
                            {pkg[key]}
                          </td>
                        ))}
                        <td>
                          <span className={`badge ${pkg.status === "ACTIVE" ? "bg-success" : "bg-danger"}`}>
                            {pkg.status}
                          </span>
                        </td>
                       
                        <td>
                          <button className="btn btn-warning btn-sm me-2" onClick={() => handleEditPackage(pkg)}>Edit</button>
                          <button className="btn btn-outline-primary btn-sm me-2" onClick={() => toggleStatus(pkg)}>
                            Change Status
                          </button>
                          <button className="btn btn-outline-danger btn-sm" onClick={() => deletePackage(pkg)}>
                            Delete Package
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default CreateEarningPackage;
